function _mmapFilterStocks(resultData, vi) {
    let stocks;
    if (resultData && resultData.intervals) {
        const times    = Object.keys(resultData.intervals).sort();
        const lastTime = times[times.length - 1];
        const raw      = resultData.intervals[lastTime] || [];
        stocks = raw
            .map(s => Object.assign({}, s, (resultData.stockInfo || {})[s.ticker] || {}))
            .filter(s => (s.market_cap || 0) >= 5000000);
    } else if (vi.stockInfo) {
        stocks = Object.values(vi.stockInfo)
            .filter(s => (s.market_cap || 0) >= 5000000);
    } else {
        return null;
    }
    if (stocks.length > 350) {
        stocks = stocks
            .sort((a, b) => (b.market_cap || 0) - (a.market_cap || 0))
            .slice(0, 350);
    }
    return stocks;
}

function _mmapApplySideSlotHiding(vi, isCenterSlot) {
    if (!vi || !vi.sectorPlatforms || vi.sectorPlatforms.size === 0) return;
    const _sortedByX = [...vi.sectorPlatforms.entries()].sort((a, b) => b[1].x - a[1].x);
    const _lastColSectors = new Set(_sortedByX.slice(0, 5).map(([name]) => String(name)));
    vi.sectorPlatforms.forEach((sp, name) => {
        if (_lastColSectors.has(String(name))) {
            sp.bg?.setAttribute('visible', isCenterSlot);
            sp.label?.setAttribute('visible', isCenterSlot);
        }
    });
    if (vi.stockBars) {
        vi.stockBars.forEach(barInfo => {
            const _s = barInfo.stock && String(barInfo.stock.sector);
            if (_lastColSectors.has(_s)) {
                barInfo.bar?.setAttribute('visible', isCenterSlot);
                barInfo.primaryLabel?.setAttribute('visible', isCenterSlot);
                barInfo.companyIcon?.setAttribute('visible', isCenterSlot);
            }
        });
    }
}

function _mmapRepositionVR(vi, is3DMode) {
    const MMAP_Y_CENTER = 0.11;
    const MMAP_Y_SIDE   = 0.30;
    const BANNER_Y_CENTER = 0.58;
    const BANNER_Y_SIDE   = 0.50;
    const TIMEDATE_Y_CENTER = 0.55;
    const TIMEDATE_Y_SIDE   = 0.47;

    // Detect carousel slot
    const _memEl = document.querySelector('[main-elements-moving]');
    const _memComp = _memEl && _memEl.components && _memEl.components['main-elements-moving'];
    const _isCenterSlot = !_memComp || _memComp.data.currentStep === 0;

    // Get large-center-panel position to know which side slot (left vs right)
    const cp = document.querySelector('#large-center-panel');
    let cpX = 0;
    if (!_isCenterSlot && cp) {
        const cpPos = cp.getAttribute('position');
        cpX = typeof cpPos === 'object' ? (cpPos.x || 0) : (parseFloat(String(cpPos).split(' ')[0]) || 0);
    }
    const _goRight = cpX > 0;

    let rotY = 0;
    if (_isCenterSlot && cp) {
        const rot = cp.getAttribute('rotation');
        rotY = -(typeof rot === 'object' ? (rot.y || 0) : (parseFloat(String(rot).split(' ')[1]) || 0));
    }

    const wrapper = document.querySelector('#stock-3d-cube-wrapper');
    if (wrapper) {
        if (_isCenterSlot) {
            if (is3DMode) {
                wrapper.setAttribute('position', '0 0 0');
                wrapper.setAttribute('rotation', `30 ${rotY} 0`);
                const _curScale = wrapper.getAttribute('scale');
                const _curScaleX = _curScale && typeof _curScale === 'object' ? _curScale.x : (_curScale ? parseFloat(String(_curScale).split(' ')[0]) : 0.85);
                if (_curScaleX > 0.05) {
                    wrapper.setAttribute('scale', '0.85 0.85 0.85');
                }
            } else {
                wrapper.setAttribute('position', `0 ${MMAP_Y_CENTER} 0`);
                wrapper.setAttribute('rotation', `90 ${rotY} 0`);
                const _curScale = wrapper.getAttribute('scale');
                const _curScaleX = _curScale && typeof _curScale === 'object' ? _curScale.x : (_curScale ? parseFloat(String(_curScale).split(' ')[0]) : 0.9);
                if (_curScaleX > 0.05) {
                    wrapper.setAttribute('scale', '0.9 0.9 0.9');
                }
            }
        } else if (!is3DMode) {
            const _tX = _goRight ? 0.08 : 0.04;
            const _tZ = _goRight ? 0   : 0.04;
            wrapper.setAttribute('position', `${_tX} ${MMAP_Y_SIDE} ${_tZ}`);
            wrapper.setAttribute('rotation', '90 0 0');
            // Only set scale if wrapper is visible; skip if mid-animation (scale ~0)
            const _curScale = wrapper.getAttribute('scale');
            const _curScaleX = _curScale && typeof _curScale === 'object' ? _curScale.x : (_curScale ? parseFloat(String(_curScale).split(' ')[0]) : 0.9);
            if (_curScaleX > 0.05) {
                wrapper.setAttribute('scale', '0.75 0.65 0.75');
            }
        }
    }

    const bannerEl = document.getElementById('stock-banner');
    if (bannerEl) {
        const bp = bannerEl.getAttribute('position') || { x: 0, y: 0, z: 0 };
        const bx = typeof bp === 'object' ? (bp.x || 0) : (parseFloat(String(bp).split(' ')[0]) || 0);
        const bz = typeof bp === 'object' ? (bp.z || 0) : (parseFloat(String(bp).split(' ')[2]) || 0);
        const bannerY = _isCenterSlot ? BANNER_Y_CENTER : BANNER_Y_SIDE;
        bannerEl.setAttribute('position', `${bx} ${bannerY} ${bz}`);
    }
    const dateEl = document.querySelector('#current-time-date');
    if (dateEl) {
        const dp = dateEl.getAttribute('position') || { x: 0, y: 0, z: 0 };
        const dx = typeof dp === 'object' ? (dp.x || 0) : (parseFloat(String(dp).split(' ')[0]) || 0);
        const dz = typeof dp === 'object' ? (dp.z || 0) : (parseFloat(String(dp).split(' ')[2]) || 0);
        const dateY = _isCenterSlot ? TIMEDATE_Y_CENTER : TIMEDATE_Y_SIDE;
        dateEl.setAttribute('position', `${dx} ${dateY} ${dz}`);
    }
    const zeroPlane = document.querySelector('#zero-plane');
    if (zeroPlane) zeroPlane.setAttribute('material', 'opacity', 0);

    const textRotY = _isCenterSlot ? rotY : 0;
    const moveArea = document.querySelector('#move-central-panel-area');
    if (moveArea) {
        if (!is3DMode) {
            const DELTA_Y = 0.38, DELTA_Z = 0.10;
            if (_isCenterSlot) {
                moveArea.setAttribute('position', `0 ${MMAP_Y_CENTER + DELTA_Y} ${DELTA_Z}`);
            } else {
                const handleX = _goRight ? 0.08 : 0.04;
                const handleZ = _goRight ? DELTA_Z : DELTA_Z + 0.04;
                moveArea.setAttribute('position', `${handleX} ${MMAP_Y_SIDE + DELTA_Y} ${handleZ}`);
            }
        } else {
            moveArea.setAttribute('position', '0 0.39 0.1');
        }
        moveArea.setAttribute('rotation', `0 ${textRotY} 0`);
    }
}

function _mmapRepositionDesktop2D(renderingObj, vi, centerPanelEl, containerWidth, containerHeight) {
    try {
        const animDur = vi._mmapRepoAnimDur || 0;
        vi._mmapRepoAnimDur = 0;

        // If we left in 3D mode (camera was moved outward), restore camera to its
        // pre-3D position before calculating the 2D optimal position.
        if (vi._mmapCameraZBefore3D !== undefined) {
            const cam = document.getElementById('camera');
            if (cam) {
                const camPos = cam.getAttribute('position') || { x: 0, y: 2.75, z: 2 };
                const cx = typeof camPos === 'string' ? parseFloat(camPos.split(' ')[0]) : (camPos.x || 0);
                const cy = typeof camPos === 'string' ? parseFloat(camPos.split(' ')[1]) : (camPos.y || 2.75);
                const savedZ = vi._mmapCameraZBefore3D;
                cam.setAttribute('position', `${cx} ${cy} ${savedZ}`);
                if (cam.object3D) cam.object3D.position.set(cx, cy, savedZ);
            }
            vi._mmapCameraZBefore3D = undefined;
        }

        const wrapper = document.querySelector('#stock-3d-cube-wrapper');
        if (wrapper) {
            const curWpRaw = wrapper.getAttribute('position');
            const wp = typeof curWpRaw === 'string'
                ? { x: parseFloat(curWpRaw.split(' ')[0]) || 0,
                    y: parseFloat(curWpRaw.split(' ')[1]) || 0,
                    z: parseFloat(curWpRaw.split(' ')[2]) || 0 }
                : (curWpRaw || { x: 0, y: 0, z: 0 });
            if (!vi.mmapWrapperOriginalPosition) {
                vi.mmapWrapperOriginalPosition = `${wp.x} ${wp.y} ${wp.z}`;
            }
            wrapper.setAttribute('rotation', '90 0 0');
            if (!vi.mmapContainerOriginalPosition) {
                const cpRaw = centerPanelEl.getAttribute('position');
                const cp = typeof cpRaw === 'string'
                    ? { x: parseFloat(cpRaw.split(' ')[0]) || 0,
                        y: parseFloat(cpRaw.split(' ')[1]) || 0,
                        z: parseFloat(cpRaw.split(' ')[2]) || 0 }
                    : (cpRaw || { x: 0, y: 0, z: 0 });
                vi.mmapContainerOriginalPosition = `${cp.x} ${cp.y} ${cp.z}`;
            }
            const origWp = vi.mmapWrapperOriginalPosition.split(' ').map(parseFloat);
            const targetWpPos = `${origWp[0] || 0} ${(origWp[1] || 0) + 0.05} ${(origWp[2] || 0) + 0.7}`;
            if (animDur > 0) {
                wrapper.setAttribute('animation__mmrepos', {
                    property: 'position',
                    to: targetWpPos,
                    dur: animDur,
                    easing: 'easeInOutQuad'
                });
            } else {
                wrapper.setAttribute('position', targetWpPos);
            }
        }
        if (vi.mmap2DPosition) {
            if (animDur > 0) {
                centerPanelEl.setAttribute('animation__mmreposel', {
                    property: 'position',
                    to: vi.mmap2DPosition,
                    dur: animDur,
                    easing: 'easeInOutQuad'
                });
            } else {
                centerPanelEl.setAttribute('position', vi.mmap2DPosition);
            }
        } else {
            const optimal  = renderingObj.calculateOptimalMarketMapPosition(vi, containerWidth, containerHeight);
            const origCp   = vi.mmapContainerOriginalPosition.split(' ').map(parseFloat);
            const curCpRaw = centerPanelEl.getAttribute('position');
            const curCp    = typeof curCpRaw === 'string'
                ? curCpRaw.split(' ').map(parseFloat)
                : [curCpRaw?.x || 0, curCpRaw?.y || 0, curCpRaw?.z || 0];
            vi.mmap2DPosition = `${origCp[0] || 0} ${curCp[1] || optimal.y} ${optimal.z}`;
            if (animDur > 0) {
                centerPanelEl.setAttribute('animation__mmreposel', {
                    property: 'position',
                    to: vi.mmap2DPosition,
                    dur: animDur,
                    easing: 'easeInOutQuad'
                });
            } else {
                centerPanelEl.setAttribute('position', vi.mmap2DPosition);
            }
        }
    } catch (e) {
        console.warn('[MarketMap] Failed to reposition for desktop mmap', e);
    }
}

function _isDesktopLightTheme(vi) {
    if (!vi || !vi.platformConfig || vi.platformConfig.platform !== 'desktop' || !document.body) {
        return false;
    }
    return document.body.classList.contains('light') || document.body.classList.contains('cb-light');
}

function _getMmapSectorTheme(vi) {
    if (_isDesktopLightTheme(vi)) {
        return {
            bgColor: '#cbd5e1',
            bgOpacity: 0.22,
            labelColor: '#111827'
        };
    }

    return {
        bgColor: '#000000',
        bgOpacity: 0.45,
        labelColor: '#ffffff'
    };
}

function _mmapRenderSectors(container, layoutResult, scaleX, scaleY, containerWidth, containerHeight, vi) {
    const theme = _getMmapSectorTheme(vi);
    const isVR3D = !!(vi && vi.platformConfig && vi.platformConfig.platform === 'vr' && vi.mmapViewMode === '3d');

    layoutResult.children.forEach(sectorNode => {
        const sectorName  = sectorNode.data.name;
        const cx = (sectorNode.x0 + sectorNode.x1) / 2;
        const cy = (sectorNode.y0 + sectorNode.y1) / 2;
        const w  = sectorNode.x1 - sectorNode.x0;
        const h  = sectorNode.y1 - sectorNode.y0;

        const xPos         = cx * scaleX - containerWidth  / 2;
        const zPos         = cy * scaleY - containerHeight / 2;
        const widthScaled  = w * scaleX;
        const heightScaled = h * scaleY;

        const isVR = !!(vi && vi.platformConfig && vi.platformConfig.platform === 'vr');
        const bg = document.createElement('a-plane');
        const bgY = isVR ? -0.002 : 0;
        bg.setAttribute('position', `${xPos} ${bgY} ${zPos - 0.01}`);
        bg.setAttribute('width',    widthScaled);
        bg.setAttribute('height',   heightScaled + 0.015);
        bg.setAttribute('rotation', '-90 0 0');
        bg.setAttribute('material', `color: ${theme.bgColor}; shader: flat; transparent: true; opacity: ${theme.bgOpacity}; depthTest: true; depthWrite: false;`);
        
        if (isVR3D) {
            bg.addEventListener('loaded', () => {
                if (bg.object3D) bg.object3D.renderOrder = 5;
            }, { once: true });
        }
        
        container.appendChild(bg);

        const label = document.createElement('a-text');
        label.setAttribute('value',    (vi.sectorNames && vi.sectorNames[sectorName]) || String(sectorName));
        label.setAttribute('align',    'left');
        label.setAttribute('color',    theme.labelColor);
        label.setAttribute('scale',    '0.05 0.05 0.05');
        label.setAttribute('rotation', '-90 0 0');
        label.setAttribute('position', `${(xPos - widthScaled / 2) + 0.005} 0 ${(zPos - heightScaled / 2) - 0.006}`);
        container.appendChild(label);

        vi.sectorPlatforms.set(String(sectorName), { bg, label, x: xPos, z: zPos, width: widthScaled, height: heightScaled });
    });
}

function _mmapIsAnimationOn(vi) {
    return typeof vi.getConfigSetting === 'function'
        ? !!vi.getConfigSetting('isAnimationOn', true)
        : !(vi.configSettings && vi.configSettings.value && vi.configSettings.value.isAnimationOn === false);
}

function _mmapBuildDelayMap(rects) {
    const areaOrder = rects
        .map((d, i) => ({ i, area: (d.width || 0) * (d.depth || 0) }))
        .sort((a, b) => a.area - b.area)
        .map((d, rank) => ({ i: d.i, rank }));
    const indexToDelay = new Map();
    areaOrder.forEach(({ i, rank }) => indexToDelay.set(i, Math.floor(rank / 10) * 120));
    return indexToDelay;
}

function _mmapCalcLabelFontSize(d, vi) {
    const area     = Math.max(0, (d.width || 0) * (d.depth || 0));
    const baseline = 0.000625;
    let   fontSize = Math.max(0.022, Math.min(0.14, 0.028 * Math.sqrt(area / (baseline || 1))));
    const cfg      = vi.mmapPrimaryLabelConfig;
    if (cfg) {
        if (cfg.fontSize !== undefined) fontSize *= cfg.fontSize;
        if (cfg.scale !== undefined) {
            const sp = cfg.scale.split(' ');
            if (sp.length >= 3) { const sv = parseFloat(sp[0]); if (!isNaN(sv)) fontSize *= sv; }
        }
    }
    return fontSize;
}

function _mmapApplyOutlineConfig(text, vi) {
    const cfg = vi.mmapPrimaryLabelConfig;
    if (!cfg) return;
    const useOutline = cfg.outlineWidth && cfg.outlineWidth !== '0%';
    if (useOutline) {
        text.setAttribute('outline-width', cfg.outlineWidth);
        if (cfg.outlineBlur)  text.setAttribute('outline-blur',  cfg.outlineBlur);
        if (cfg.outlineColor) text.setAttribute('outline-color', cfg.outlineColor);
        text.setAttribute('stroke-width', '0%');
    }
}

function _mmapApplyLabelPostSetup(text) {
    setTimeout(() => {
        if (text.object3D) {
            text.object3D.traverse(child => {
                if (child.material) {
                    const mats = Array.isArray(child.material) ? child.material : [child.material];
                    mats.forEach(mat => {
                        if (mat) {
                            if (mat.emissive) {
                                mat.emissive.setHex(0x000000);
                                mat.emissiveIntensity = 0;
                            }
                            mat.userData = mat.userData || {};
                            mat.userData.bloom = false;
                        }
                    });
                }
            });
        }
    }, 100);
    const setRenderOrder = () => { if (text.object3D) text.object3D.renderOrder = 9999; };
    if (text.object3D) { setRenderOrder(); } else { text.addEventListener('loaded', setRenderOrder, { once: true }); }
}

const MMAP_DESKTOP_3D_BAR_OPACITY = 0.88;
const MMAP_DESKTOP_2D_BAR_OPACITY = 0.94;

function _mmapCreate3DBar(d, { percValue, color, isVR, isAnimationOn, isModeSwitch, delay, dropDurMs,
                               rawBarHeight, absBarHeight, yCenter, vi }) {
    const box = document.createElement('a-box');
    box.setAttribute('width',  d.width);
    box.setAttribute('height', absBarHeight);
    box.setAttribute('depth',  d.depth);

    const barOpacityVR = 0.82;

    if (isAnimationOn) {
        const targetOpacity = isVR ? barOpacityVR : MMAP_DESKTOP_3D_BAR_OPACITY;
        box.setAttribute('position', `${d.x} 0 ${-d.z}`);
        box.setAttribute('scale', '1 0.001 1');
        box.setAttribute('material', isVR
            ? `color: ${color}; opacity: ${isModeSwitch ? targetOpacity : 0}; transparent: true; side: double; depthTest: true; depthWrite: ${isModeSwitch ? 'true' : 'false'}`
            : `color: ${color}; opacity: ${isModeSwitch ? targetOpacity : 0}; transparent: true; side: double; depthTest: true; depthWrite: true`);
        box.setAttribute('animation__grow', { property: 'scale', from: '1 0.001 1', to: '1 1 1', dur: dropDurMs, delay, easing: 'easeOutQuad' });
        box.setAttribute('animation__rise', { property: 'position', from: `${d.x} 0 ${-d.z}`, to: `${d.x} ${yCenter} ${-d.z}`, dur: dropDurMs, delay, easing: 'easeOutQuad' });
        if (!isModeSwitch) {
            box.setAttribute('animation__fade', { property: 'material.opacity', from: 0.0, to: targetOpacity, dur: Math.max(200, dropDurMs - 50), delay, easing: 'linear' });
            if (isVR) {
                const totalDelay = delay + Math.max(200, dropDurMs - 50);
                setTimeout(() => {
                    if (box.parentNode) {
                        box.setAttribute('material', { color, opacity: barOpacityVR, transparent: true, side: 'double', depthTest: true, depthWrite: true });
                    }
                }, totalDelay + 50);
            }
        } else {
            if (isVR) {
                setTimeout(() => {
                    if (box.parentNode) {
                        box.setAttribute('material', { color, opacity: barOpacityVR, transparent: true, side: 'double', depthTest: true, depthWrite: true });
                    }
                }, delay + dropDurMs + 50);
            }
        }
    } else {
        box.setAttribute('position', `${d.x} ${yCenter} ${-d.z}`);
        box.setAttribute('material', isVR
            ? `color: ${color}; opacity: ${barOpacityVR}; transparent: true; side: double; depthTest: true; depthWrite: true`
            : `color: ${color}; opacity: ${MMAP_DESKTOP_3D_BAR_OPACITY}; transparent: true; side: double; depthTest: true; depthWrite: true`);
    }
    box.setAttribute('data-raycastable', '');

    let textEl = null;
    if (d.width > 0.02) {
        const pct  = typeof percValue === 'number' ? `\n${percValue.toFixed(1)}%` : '';
        const text = document.createElement('a-troika-text');
        text.setAttribute('value',          `${d.ticker || d.name || ''}${pct}`);
        text.setAttribute('align',          'center');
        text.setAttribute('anchor',         'center');
        text.setAttribute('color',          '#FFFFFF');
        text.setAttribute('class',          'billboard');
        text.setAttribute('stroke-width',   '2.5%');
        text.setAttribute('stroke-color',   '#000000');
        text.setAttribute('stroke-opacity', '1.0');
        text.setAttribute('outline-width',  '0%');
        text.setAttribute('depth-offset',   '0');
        text.setAttribute('fill-opacity',   '1.0');
        const fontSize = _mmapCalcLabelFontSize(d, vi);
        text.setAttribute('font-size',      fontSize);
        _mmapApplyOutlineConfig(text, vi);

        const labelYOffset = fontSize * 1.4 + 0.005;
        const topY = rawBarHeight >= 0
            ? absBarHeight + labelYOffset
            : -(absBarHeight + labelYOffset);

        if (isAnimationOn) {
            if (isModeSwitch) {
                text.setAttribute('position', `${d.x} ${topY} ${-d.z}`);
                text.setAttribute('opacity',  '0');
                text.setAttribute('animation__fade', { property: 'opacity', from: 0, to: 1, dur: 350, delay: delay + Math.floor(dropDurMs / 2), easing: 'linear' });
            } else {
                text.setAttribute('position', `${d.x} 0 ${-d.z}`);
                text.setAttribute('opacity',  '0');
                text.setAttribute('animation__rise', { property: 'position', to: `${d.x} ${topY} ${-d.z}`, dur: dropDurMs, delay, easing: 'easeOutQuad' });
                text.setAttribute('animation__fade', { property: 'opacity', from: 0, to: 1, dur: 250, delay: delay + Math.floor(dropDurMs / 2), easing: 'linear' });
            }
        } else {
            text.setAttribute('position', `${d.x} ${topY} ${-d.z}`);
        }
        _mmapApplyLabelPostSetup(text);
        textEl = text;
    }

    return { box, textEl };
}

function _mmapCreate2DBar(d, { color, isVR, isAnimationOn, delay, dropDurMs, vi }) {
    const plane = document.createElement('a-plane');
    plane.setAttribute('position', `${d.x} 0 ${isAnimationOn ? (-d.z - 0.6) : -d.z}`);
    plane.setAttribute('rotation', '-90 0 0');
    plane.setAttribute('width',    d.width);
    plane.setAttribute('height',   d.depth);
    if (isVR) {
        plane.setAttribute('material', isAnimationOn
            ? `color: ${color}; opacity: 0; transparent: true; shader: flat; side: double; depthTest: true; depthWrite: false`
            : `color: ${color}; opacity: 1.0; transparent: false; shader: flat; side: double; depthTest: true; depthWrite: true`);
    } else {
        plane.setAttribute('material', `color: ${color}; opacity: ${isAnimationOn ? 0.0 : MMAP_DESKTOP_2D_BAR_OPACITY}; transparent: true; side: double; depthTest: true; depthWrite: true`);
    }
    plane.setAttribute('data-raycastable', '');

    if (isAnimationOn) {
        plane.setAttribute('animation__drop', { property: 'position', to: `${d.x} 0 ${-d.z}`, dur: dropDurMs, delay, easing: 'easeOutQuad' });
        plane.setAttribute('animation__fade', { property: 'material.opacity', from: 0.0, to: isVR ? 1.0 : MMAP_DESKTOP_2D_BAR_OPACITY, dur: Math.max(200, dropDurMs - 50), delay, easing: 'linear' });
        if (isVR) {
            const totalDelay = delay + Math.max(200, dropDurMs - 50);
            setTimeout(() => {
                if (plane.parentNode) {
                    plane.setAttribute('material', { color, opacity: 1.0, transparent: false, shader: 'flat', side: 'double', depthTest: true, depthWrite: true });
                }
            }, totalDelay + 50);
        }
    }

    if (d.width > 0.02) {
        const pct  = typeof d.todaysChangePerc === 'number' ? `\n${d.todaysChangePerc.toFixed(1)}%` : '';
        const text = document.createElement('a-troika-text');
        text.setAttribute('value',          `${d.ticker || d.name || ''}${pct}`);
        text.setAttribute('align',          'center');
        text.setAttribute('anchor',         'center');
        text.setAttribute('color',          '#FFFFFF');
        text.setAttribute('position',       isAnimationOn ? '0 100 0.01' : '0 0 0.01');
        text.setAttribute('rotation',       '0 0 0');
        text.setAttribute('stroke-width',   '2.5%');
        text.setAttribute('stroke-color',   '#000000');
        text.setAttribute('stroke-opacity', '1.0');
        text.setAttribute('outline-width',  '0%');
        text.setAttribute('depth-offset',   '0');
        text.setAttribute('fill-opacity',   '1.0');
        text.setAttribute('font-size',      _mmapCalcLabelFontSize(d, vi));
        _mmapApplyOutlineConfig(text, vi);

        if (isAnimationOn) {
            text.setAttribute('opacity', '0');
            text.setAttribute('animation__fade',        { property: 'opacity',   from: 0, to: 1,        dur: 250, delay: delay + Math.floor(dropDurMs / 2), easing: 'linear' });
            text.setAttribute('animation__restore_pos', { property: 'position',  to: '0 0 0.01',       dur: 500, delay: delay + dropDurMs, easing: 'easeOutQuad' });
        }
        _mmapApplyLabelPostSetup(text);
        plane.appendChild(text);
    }

    return plane;
}

function _mmapFinalize3D(renderingObj, vi, rects, heightScale3D, maxAbsPerc3D, max3DBarHeight, isVR) {
    vi.zeroPlane      = 0;
    vi.heightValueFn  = d => d.todaysChangePerc || 0;
    vi.heightScale    = heightScale3D;
    vi.maxHeightValue = maxAbsPerc3D;
    const maxPos3D = Math.max(...rects.map(d => d.todaysChangePerc || 0), 0);
    const maxNeg3D = Math.max(...rects.map(d => -(d.todaysChangePerc || 0)), 0);
    vi._cachedGlobalMax = { max: maxAbsPerc3D, hasNegative: maxNeg3D > 0, maxPos: maxPos3D, maxNeg: maxNeg3D };

    if (!isVR) {
        setTimeout(() => {
            if (!vi.data || vi.data.dataSource !== 'mmap') return;
            vi.updateBillboards?.(true);
            window.StockCubeCore.recalcLabelPositions.call(vi);
        }, 100);
    } else {
        setTimeout(() => {
            vi.updateBillboards?.(true);
            window.StockCubeCore.recalcLabelPositions.call(vi);
        }, 200);
    }
}

window.MarketMapSharedRendering = {

    renderMarketMap: function (visualizer, result) {
        const vi = (visualizer && visualizer.el) ? visualizer : this;
        const resultData = (visualizer && visualizer.el)
            ? result
            : ((visualizer && visualizer.intervals) ? visualizer : (vi.currentData || null));
        if (!vi || !vi.el) return;

        const is3DMode = vi.mmapViewMode === '3d';
        const isVR     = !!(vi.platformConfig && vi.platformConfig.platform === 'vr');
        const container = vi.el;

        if (!isVR) {
            const wrapper = document.getElementById('stock-3d-cube-wrapper');
            if (wrapper) {
                const _wrapperRot = is3DMode ? '30 0 0' : '90 0 0';
                const _curRot = wrapper.getAttribute('rotation');
                const _curRotStr = typeof _curRot === 'object'
                    ? `${Math.round(_curRot.x || 0)} ${Math.round(_curRot.y || 0)} ${Math.round(_curRot.z || 0)}`
                    : String(_curRot || '').trim();
                if (_curRotStr !== _wrapperRot) {
                    wrapper.setAttribute('rotation', _wrapperRot);
                }
            }
        }

        while (container.firstChild) container.removeChild(container.firstChild);

        if (!vi.mmapPrimaryLabelConfig) {
            vi.mmapPrimaryLabelConfig = {
                fontSize: 2, scale: '0.1 0.1 0.1',
                outlineWidth: '15%', outlineBlur: '20%', outlineColor: '#000000'
            };
        }

        const filteredStockInfo = _mmapFilterStocks(resultData, vi);
        if (!filteredStockInfo) return;

        const D3_W = 1000, D3_H = 840;
        const containerWidth = 1.0, containerHeight = 0.84;

        if (isVR) {
            _mmapRepositionVR(vi, is3DMode);
        }

        const layoutOpts   = is3DMode ? { gap: window.MMAP_3D_SECTOR_GAP, paddingInner: (window.MMAP_3D_BAR_GAP !== undefined ? window.MMAP_3D_BAR_GAP : 0.1) } : undefined;
        const layoutResult = window.MarketMapLayout.computeMarketMapLinearSectorsVR(filteredStockInfo, D3_W, D3_H, layoutOpts);
        const rects        = window.MarketMapLayout.convertD3ToAFrameRects(layoutResult.leaves(), D3_W, D3_H, containerWidth, containerHeight);

        vi.stockBars       = new Map();
        vi.sectorPlatforms = new Map();

        vi.stockBars       = new Map();
        vi.sectorPlatforms = new Map();

        const scaleX = containerWidth  / D3_W;
        const scaleY = containerHeight / D3_H;
        _mmapRenderSectors(container, layoutResult, scaleX, scaleY, containerWidth, containerHeight, vi);

        const isAnimationOn  = _mmapIsAnimationOn(vi);
        const growDelayOffset = vi._mmapGrowDelayOffset || 0;
        const isModeSwitch    = growDelayOffset > 0;
        vi._mmapGrowDelayOffset = 0;
        const indexToDelay   = isModeSwitch ? null : _mmapBuildDelayMap(rects);
        const max3DBarHeight = (window.MMAP_3D_MAX_HEIGHT !== undefined) ? window.MMAP_3D_MAX_HEIGHT : 0.3;
        const maxAbsPerc3D   = is3DMode ? Math.max(...rects.map(d => Math.abs(d.todaysChangePerc || 0)), 0.01) : 0;
        const heightScale3D  = is3DMode ? max3DBarHeight / maxAbsPerc3D : 0;

        rects.forEach((d, i) => {
            const percValue = d.todaysChangePerc || 0;
            const color     = vi.getGradientColor(percValue);
            const delay     = isModeSwitch ? growDelayOffset : (indexToDelay.get(i) || 0);
            const dropDurMs = isModeSwitch ? 700 : (d.width < 0.015 ? 100 : 300);

            if (is3DMode) {
                const rawBarHeight = percValue * heightScale3D;
                const absBarHeight = Math.max(Math.abs(rawBarHeight), 0.002);
                const yCenter      = rawBarHeight >= 0 ? absBarHeight / 2 : -absBarHeight / 2;

                const { box, textEl } = _mmapCreate3DBar(d, {
                    percValue, color, isVR,
                    isAnimationOn: isAnimationOn || isModeSwitch,
                    isModeSwitch,
                    delay, dropDurMs,
                    rawBarHeight, absBarHeight, yCenter, vi
                });
                container.appendChild(box);
                if (textEl) container.appendChild(textEl);

                box.setAttribute('stock-bar', { stockData: JSON.stringify(d), baseColor: color });
                const barLabelYOffset = textEl ? ((() => {
                    const fs = _mmapCalcLabelFontSize(d, vi);
                    return fs * 1.4 + 0.005;
                })()) : (vi.labelYOffset || 0.03);
                vi.stockBars.set(d.ticker || d.name, {
                    bar: box, primaryLabel: textEl, stock: d,
                    x: d.x, z: d.z, lastHeight: rawBarHeight,
                    labelYOffset: barLabelYOffset
                });
            } else {
                const plane = _mmapCreate2DBar(d, { color, isVR, isAnimationOn, delay, dropDurMs, vi });
                container.appendChild(plane);

                plane.setAttribute('stock-bar', { stockData: JSON.stringify(d), baseColor: color });
                vi.stockBars.set(d.ticker || d.name, { bar: plane, stock: d, x: d.x, z: d.z });
            }
        });

        if (is3DMode) {
            _mmapFinalize3D(this, vi, rects, heightScale3D, maxAbsPerc3D, max3DBarHeight, isVR);
        }

        if (isVR && !is3DMode) {
            const _memEl = document.querySelector('[main-elements-moving]');
            const _memComp = _memEl && _memEl.components && _memEl.components['main-elements-moving'];
            const _isCenterSlot = !_memComp || _memComp.data.currentStep === 0;
            if (!_isCenterSlot) {
                _mmapApplySideSlotHiding(vi, false);
            }
        }

        if (!isVR) {
            setTimeout(() => {
                const wrapper = document.getElementById('stock-3d-cube-wrapper');
                if (wrapper && typeof vi.adjustChartToFitViewport === 'function') {
                    vi.adjustChartToFitViewport(
                        vi.stockBars,
                        vi.heightScale || 1,
                        vi.maxHeightValue || 1,
                        0,
                        0,
                        wrapper
                    );
                }
            }, 50);
        }
    },

    updateMmap3DLabelVisibility: function (vi, camWorldPos) {
        const ANGULAR_THRESHOLD = 0.02;
        if (!vi.el.object3D) return;
        vi.el.object3D.updateWorldMatrix(true, false);
        const mw         = vi.el.object3D.matrixWorld;
        const worldScale = mw.getMaxScaleOnAxis();
        const workVec    = new AFRAME.THREE.Vector3();
        vi.stockBars.forEach((barInfo) => {
            if (!barInfo || !barInfo.primaryLabel || !barInfo.primaryLabel.object3D) return;
            const s = barInfo.stock;
            if (!s) { barInfo.primaryLabel.object3D.visible = true; return; }
            const w = s.width || 0;
            const d = s.depth || 0;
            if (w === 0 && d === 0) { barInfo.primaryLabel.object3D.visible = true; return; }
            const worldDiag = Math.sqrt(w * w + d * d) * worldScale;
            workVec.set(barInfo.x, 0, -barInfo.z);
            workVec.applyMatrix4(mw);
            const dist = workVec.distanceTo(camWorldPos);
            barInfo.primaryLabel.object3D.visible = dist < 0.001 || (worldDiag / dist) >= ANGULAR_THRESHOLD;
        });
    },

    updateMmapDesktopTheme: function (vi, isLight) {
        if (!vi || !vi.sectorPlatforms || !vi.sectorPlatforms.size) return;

        const theme = isLight
            ? { bgColor: '#cbd5e1', bgOpacity: 0.22, labelColor: '#111827' }
            : { bgColor: '#000000', bgOpacity: 0.45, labelColor: '#ffffff' };

        vi.sectorPlatforms.forEach(({ bg, label }) => {
            if (bg) {
                bg.setAttribute('material', 'color', theme.bgColor);
                bg.setAttribute('material', 'opacity', theme.bgOpacity);
            }
            if (label) {
                label.setAttribute('color', theme.labelColor);
            }
        });
    },
};

window.MarketMapVisualizer = window.MarketMapSharedRendering;
